import React, { FC } from 'react';
import { Accordion as MuiAccordion, AccordionProps, styled } from '@material-ui/core';

const StyledAccordion = styled(MuiAccordion)({
  '&:before': {
    display: 'none',
  },
});

const Accordion: FC<AccordionProps> = (props) => <StyledAccordion square {...props} />;

export default Accordion;
